<div class="news-carousel custom-carousel" *ngIf="listProductNews.length > 0">
    <div class="container"></div>
    <h2 style="font-family: 'Poppins-Bold'; list-style: 1.5rem; margin-bottom: 16px">
        {{ 'IRONSIDE.new-productDetail.MOST_VIEWED_PRODUCTS' | translate }}
    </h2>

    <div class="px-80 wrap-carousel">
        <ng-container *ngIf="loading">
            <div class="secsion-loading">
                <mat-spinner [diameter]="50"></mat-spinner>
            </div>
        </ng-container>

        <p-carousel
            [ngClass]="{ 'hide-arrows': listProductNews.length <= 1 }"
            [value]="listProductNews"
            [numVisible]="4"
            [numScroll]="4"
            [circular]="false"
        >
            <ng-template let-news pTemplate="item">
                <div
                    class="item-news item-custom"
                    (click)="onRedirecProductDetailByProduct(news?.referenceProduct)"
                >
                    <div class="relative mb-1" style="padding: 4px">
                        <img
                            style="height: 160px; object-fit: contain"
                            [src]="getResourceValid(news?.fullExtendData)"
                            class="w-full border-round"
                        />
                    </div>
                    <div class="title-wrap">
                        <p class="title-news font-bold">
                            {{ news?.shortDescription | translateDynamicLanguage }}
                        </p>
                        <span>Marque : {{ news?.brand | translateDynamicLanguage }}</span>
                    </div>
                </div>
            </ng-template>
        </p-carousel>
    </div>
</div>
